import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1A1A1A] text-white pt-16 pb-8" data-id="element-23">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-25">
          {/* Brand */}
          <div data-id="element-26">
            <a href="#" className="text-2xl font-serif font-bold text-white block mb-6" data-id="element-27">
              新加坡爽吧 <span className="text-[#C9A96E]" data-id="element-28">Shiok8</span>
            </a>
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-29">
              新加坡历史最悠久的专业按摩推荐平台，致力于为用户提供高品质、可信赖的按摩服务体验。
            </p>
            <div className="flex space-x-4" data-id="element-30">
              <a href="#" className="text-gray-400 hover:text-[#C9A96E] transition-colors" data-id="element-31">
                <Facebook size={20} data-id="element-32" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C9A96E] transition-colors" data-id="element-33">
                <Instagram size={20} data-id="element-34" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C9A96E] transition-colors" data-id="element-35">
                <Twitter size={20} data-id="element-36" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-37">
            <h4 className="text-lg font-bold mb-6 text-[#FDF8F0]" data-id="element-38">
              快速链接 (Links)
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-39">
              <li data-id="element-40">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-41">
                  关于我们 (About Us)
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-43">
                  服务项目 (Services)
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-45">
                  技师入驻 (Join Us)
                </a>
              </li>
              <li data-id="element-46">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-47">
                  隐私政策 (Privacy Policy)
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-48">
            <h4 className="text-lg font-bold mb-6 text-[#FDF8F0]" data-id="element-49">
              热门服务 (Popular)
            </h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-50">
              <li data-id="element-51">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-52">
                  中式推拿 (Chinese Tuina)
                </a>
              </li>
              <li data-id="element-53">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-54">
                  泰式按摩 (Thai Massage)
                </a>
              </li>
              <li data-id="element-55">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-56">
                  精油SPA (Oil SPA)
                </a>
              </li>
              <li data-id="element-57">
                <a href="#" className="hover:text-[#C9A96E] transition-colors" data-id="element-58">
                  足底按摩 (Foot Reflexology)
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-59">
            <h4 className="text-lg font-bold mb-6 text-[#FDF8F0]" data-id="element-60">
              联系我们 (Contact)
            </h4>
            <ul className="space-y-4 text-sm text-gray-400" data-id="element-61">
              <li className="flex items-start" data-id="element-62">
                <MapPin className="w-5 h-5 mr-3 text-[#C9A96E] flex-shrink-0" data-id="element-63" />
                <span data-id="element-64">
                  10 Anson Road, International Plaza, Singapore 079903
                </span>
              </li>
              <li className="flex items-center" data-id="element-65">
                <Phone className="w-5 h-5 mr-3 text-[#C9A96E] flex-shrink-0" data-id="element-66" />
                <span data-id="element-67">+65 6123 4567</span>
              </li>
              <li className="flex items-center" data-id="element-68">
                <Mail className="w-5 h-5 mr-3 text-[#C9A96E] flex-shrink-0" data-id="element-69" />
                <span data-id="element-70">support@shiok8.sg</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-500" data-id="element-71">
          <p data-id="element-72">© 2003-2026 新加坡爽吧 Shiok8. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}